"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M12.146 3.591v.844a3.506 3.506 0 0 1 2.998 3.461v4.54a3.516 3.516 0 0 1-3.512 3.511 3.516 3.516 0 0 1-3.512-3.512V7.896c0-1.77 1.32-3.225 3.026-3.464v-.84a2.537 2.537 0 0 0-2.534-2.536c-1.452 0-2.588 1.137-2.588 2.535v2.026A2.566 2.566 0 0 1 3.46 8.18C1.999 8.18.849 7.03.849 5.617V2.304h1v3.313c0 .862.7 1.563 1.563 1.563.91 0 1.612-.7 1.612-1.563V3.591A3.538 3.538 0 0 1 8.557.056c2.004 0 3.589 1.586 3.589 3.535Zm-.514 11.356a2.515 2.515 0 0 1-2.512-2.512V7.896c0-1.22.873-2.237 2.026-2.464v2.625H9.878v1h4.266v3.378a2.515 2.515 0 0 1-2.512 2.512Zm2.512-7.05v.16h-1.998v-2.62a2.516 2.516 0 0 1 1.998 2.46Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M18.122 5.28v1.427a4.944 4.944 0 0 1 4.566 4.922v7.333a4.947 4.947 0 0 1-4.941 4.94h-.42a4.947 4.947 0 0 1-4.94-4.94v-7.333a4.943 4.943 0 0 1 4.61-4.925V5.281a4.063 4.063 0 0 0-4.06-4.058h-.083A4.063 4.063 0 0 0 8.795 5.28v3.087a3.71 3.71 0 0 1-3.705 3.705c-2.115 0-3.777-1.662-3.777-3.705V3.52h1.125v4.847a2.583 2.583 0 0 0 2.58 2.58c1.495 0 2.652-1.157 2.652-2.58V5.28A5.19 5.19 0 0 1 12.854.098h.084a5.19 5.19 0 0 1 5.184 5.183Zm-.375 17.497h-.42a3.82 3.82 0 0 1-3.816-3.816V11.63c0-1.991 1.539-3.612 3.486-3.783v4.437h-1.932v1.125h6.498v5.554a3.82 3.82 0 0 1-3.816 3.816Zm3.816-11.148v.654h-3.441V7.85c1.925.192 3.44 1.803 3.44 3.779Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M24.162 7.041v1.901c3.399.257 6.088 3.098 6.088 6.563v9.777a6.596 6.596 0 0 1-6.588 6.588h-.56a6.596 6.596 0 0 1-6.587-6.588v-9.777c0-3.484 2.72-6.338 6.146-6.566V7.041a5.418 5.418 0 0 0-5.412-5.41h-.11a5.418 5.418 0 0 0-5.412 5.41v4.116a4.945 4.945 0 0 1-4.94 4.94c-2.821 0-5.037-2.216-5.037-4.94V4.694h1.5v6.463a3.444 3.444 0 0 0 3.44 3.44c1.994 0 3.536-1.543 3.536-3.44V7.041c0-3.81 3.101-6.91 6.912-6.91h.111c3.812 0 6.913 3.1 6.913 6.91Zm-.5 23.33h-.56a5.094 5.094 0 0 1-5.087-5.089v-9.777c0-2.655 2.05-4.816 4.646-5.044v5.916h-2.576v1.5h8.665v7.405a5.094 5.094 0 0 1-5.088 5.088Zm5.088-14.866v.872h-4.588v-5.91c2.568.255 4.588 2.403 4.588 5.038Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M36.241 10.335v3.109c5.19.418 9.288 4.768 9.288 10.063v14.387C45.529 43.468 40.995 48 35.423 48h-.327c-5.572 0-10.105-4.533-10.105-10.105V23.507c0-5.325 4.144-9.691 9.375-10.068v-3.104c0-4.664-3.795-8.46-8.46-8.46h-.17c-4.665 0-8.46 3.796-8.46 8.46v6.278c0 4.041-3.288 7.329-7.328 7.329h-.15c-4.04 0-7.327-3.288-7.327-7.329v-9.65h1.875v9.65A5.459 5.459 0 0 0 9.8 22.067h.149a5.458 5.458 0 0 0 5.452-5.454v-6.278C15.4 4.636 20.037 0 25.735 0h.17c5.7 0 10.336 4.636 10.336 10.335Zm-.818 35.79h-.327c-4.537 0-8.23-3.692-8.23-8.23V23.507c0-4.291 3.304-7.822 7.5-8.193v9.468H30.44v1.875h13.215v11.238c0 4.538-3.693 8.23-8.23 8.23Zm8.23-22.618v1.275h-7.411V15.32c4.155.412 7.412 3.927 7.412 8.188Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M48.322 13.78v4.145c6.92.558 12.383 6.357 12.383 13.418v19.183C60.705 57.956 54.66 64 47.231 64h-.436c-7.429 0-13.473-6.044-13.473-13.474V31.343c0-7.1 5.525-12.922 12.5-13.424V13.78c0-6.219-5.06-11.28-11.28-11.28h-.228c-6.219 0-11.28 5.061-11.28 11.28v8.371c0 5.388-4.383 9.771-9.77 9.771h-.199c-5.387 0-9.77-4.383-9.77-9.771V9.283h2.5v12.868c0 4.01 3.262 7.271 7.27 7.271h.2c4.008 0 7.27-3.261 7.27-7.271V13.78C20.534 6.182 26.715 0 34.314 0h.226c7.6 0 13.781 6.182 13.781 13.78Zm-1.09 47.72h-.437c-6.05 0-10.973-4.923-10.973-10.974V31.343c0-5.722 4.405-10.429 10-10.924v12.624h-5.237v2.5h17.62v14.983c0 6.051-4.923 10.974-10.974 10.974Zm10.973-30.157v1.7h-9.883V20.425c5.541.55 9.883 5.236 9.883 10.918Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconComputerMouse = function IconComputerMouse(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Computer Mouse' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "ComputerMouse"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconComputerMouse.sizes = [16, 24, 32, 48, 64];
IconComputerMouse.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconComputerMouse;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/account-experience/ComputerMouse.js
// module id = 1699
// module chunks = 0